import Constant from '@/const';
import axios from 'axios';

const exportPCareReport = async params => {
  try {
    const { startDate = '', endDate = '' } = params;
    const response = await axios.get(
      Constant.apiUrl.concat(
        `/pcare/report/export?startDate=${startDate}&endDate=${endDate}`,
      ),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default exportPCareReport;
